export type FilmType = "movies" | "tv";

export interface Film {
  id: string;
  title: string;
  type: FilmType;
  year: number;
  region: string;
  rating: number;
  director: string;
  cast: string[];
  genres: string[];
  cover: string;
  summary: string;
  plot: string[];
  releaseDate: string;
  popularity: number;
  featured: boolean;
}

export interface Collection {
  id: string;
  title: string;
  description: string;
  image: string;
  query: string;
}

export interface FilmFilters {
  type?: FilmType;
  year?: string;
  region?: string;
  rating?: string;
  sort?: "latest" | "popularity" | "rating";
}

export const TYPE_LABEL: Record<FilmType, string> = {
  movies: "电影",
  tv: "电视剧",
};